import React from 'react'
import './Developer.css'

export default function Developer() {
    return (
        <div className='developerContain'>
            <p>
                Desarrollado por
            </p>
            <h4>INOVVA</h4>
        </div>
    )
}
